import './clientEntry';
import './initializeI18n';

import {
  buildClientApp,
  generateCarleadCreationConfig,
} from '@retail/funnel-components';
import pckJson from '../package.json';
import clientRoutes from './clientRoutes';
import { funnelOptions } from './funnelOptions';

const appConfig = generateCarleadCreationConfig('fr', pckJson, funnelOptions);

buildClientApp(appConfig, clientRoutes);
